import React from 'react';
import { useNavigate } from 'react-router-dom';

import './video-component.scss';

interface VideoProps {
  video: {
    id: string;
    title: string;
    description: string;
    duration: string;
    publishDate: string;
    youtubeId: string;
    instructor: {
      name: string;
      title: string;
      avatar: string;
    };
    chapters: Array<{
      number: number;
      title: string;
      duration: string;
      startTime: string;
    }>;
    tags: string;
    relatedVideos?: Array<{
      id: string;
      title: string;
      duration: string;
      thumbnail: string;
    }>;
  };
  onBack?: () => void;
}

const VideoComponent: React.FC<VideoProps> = ({ video }) => {
  const navigate = useNavigate();

  const handleRelatedVideoClick = (relatedId: string) => {
    navigate(`/wellness/videos/${relatedId}`);
    // Scroll to top when navigating to a new video
    window.scrollTo(0, 0);
  };

  return (
    <div className="video-component">
      <div className="phone-frame">
        {/* Video Container */}
        <div className="video-container">
          <iframe
            className="youtube-embed"
            src={`https://www.youtube.com/embed/${video.youtubeId}?autoplay=1`}
            title={video.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />

          {/* Header Overlay */}
          {/* <div className="header-overlay">
            <button className="back-button" onClick={onBack}>←</button>
            <div className="header-actions">
              <button className="action-btn">🔖</button>
              <button className="action-btn">↗</button>
              <button className="action-btn">⋯</button>
            </div>
          </div> */}

          {/* Video Controls */}
          {/* <div className="video-controls">
            <div className="progress-container">
              <div className="progress-bar">
                <div className="progress-fill"></div>
              </div>
            </div>
            <div className="controls-row">
              <div className="time-display">5:24 / {video.duration}</div>
              <div className="control-buttons">
                <button className="control-btn">⏮</button>
                <button className="control-btn">⏸</button>
                <button className="control-btn">⏭</button>
                <button className="control-btn">🔊</button>
                <button className="control-btn">⛶</button>
              </div>
            </div>
          </div>*/}
        </div> 

        {/* Content Section */}
        <div className="content-section">
          {/* Video Meta */}
          <div className="video-meta">
            <span className="meta-badge">Video</span>
            <span>🕐 {video.duration}</span>
            <span>•</span>
            <span>{video.publishDate}</span>
          </div>

          {/* Title */}
          <h1 className="video-title">{video.title}</h1>

          {/* Description */}
          <div className="video-description">
            {video.description}
          </div>

          {/* Tags */}
          <div className="tags">
            {video.tags?.split(',').map((tag: string, index: number) => (
              <span key={index} className="tag">{tag}</span>
            ))}
          </div>

          {/* Related Videos */}
          {video.relatedVideos && (
            <div className="related-videos">
              <div className="screen-title">More Videos You Might Like</div>
              {video.relatedVideos.map((related, index) => (
                <div 
                  key={index} 
                  className="related-video"
                  onClick={() => handleRelatedVideoClick(related.id)}
                >
                  <div className="related-thumbnail">
                    {related.thumbnail}
                    <div className="duration-badge">{related.duration}</div>
                  </div>
                  <div className="related-content">
                    <div className="related-title">{related.title}</div>
                    <div className="related-meta">
                      <span className="meta-badge">Video</span>
                      <span>{related.duration}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Floating Controls */}
        {/* <div className="floating-controls">
          <button className="floating-btn">❤️</button>
          <button className="floating-btn">💾</button>
          <button className="floating-btn">💬</button>
          <button className="floating-btn">↗</button>
        </div> */}
      </div>
    </div>
  );
};

export default VideoComponent;
